import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ReactColorCustom from '../ReactColorCustom';
import CheckIcon from '../../../../icons/check.svg';
import hexImage from '../../../../img/colors.png';
import styles from './styles.scss';

export default class LegacyColorPicker extends React.Component {
    static propTypes = {
        defaultColors: PropTypes.array,
        className: PropTypes.string,
        value: PropTypes.string,
        name: PropTypes.string,
        disabled: PropTypes.bool,
        onChange: PropTypes.func.isRequired,
        noHex: PropTypes.bool,
    };

    static defaultProps = {
        color: '#51B3F7',
        defaultColors: ['#51B3F7', '#903671', '#6D68CB', '#53CEC6', '#F9BC73', '#2F3542'],
        noHex: false,
    };

    constructor(props) {
        super(props);

        this.state = {
            hexShown: false,
            hexValid: true,
        };

        this.handleChange = this.handleChange.bind(this);
        this.showHexinput = this.showHexinput.bind(this);
        this.handleCustomChange = this.handleCustomChange.bind(this);
    }

    handleChange(e) {
        const { onChange, defaultColors, disabled } = this.props;

        if (disabled) {
            return;
        }

        const target = e.target;
        const value = target.value[0] !== '#' ? '#' + target.value : target.value;
        const regexp = /^[0-9A-Fa-f]+$/;

        this.setState({
            hexValid: hexValid(defaultColors, value),
        });

        if (target.getAttribute('name') === 'hexInput') {
            if (target.value === '' || regexp.test(target.value)) {
                onChange('#' + target.value);
            }
        } else {
            this.setState({
                hexShown: false,
            });

            onChange(target.value);
        }
    }

    handleCustomChange(color, event) {
        const { onChange } = this.props;

        onChange(color.hex);
    }

    showHexinput(e) {
        e.preventDefault();

        const { onChange } = this.props;

        onChange('#0087ff');

        this.setState({
            hexShown: true,
        });
    }

    render() {
        const { defaultColors, value, className, noHex, disabled } = this.props;
        const { hexShown, hexValid } = this.state;
        const isCustom = !defaultColors.includes(value);

        return (
            <div className={classNames(styles.root, disabled && styles.disabled, className)}>
                <div className={styles.colorsList}>
                    {defaultColors.map((index) => (
                        <label key={index} style={{ background: index }}>
                            <input type="radio" value={index} checked={value === index} onChange={this.handleChange} />
                            {value === index && !hexShown && <CheckIcon className={styles.check} />}
                        </label>
                    ))}
                    {!noHex && (
                        <>
                            <div className={styles.customColorBtn}>
                                <img src={hexImage} alt="HEX button" onClick={this.showHexinput} />
                                {(hexShown || isCustom) && value !== null && <CheckIcon className={styles.check} />}
                            </div>
                            {value && isCustom && (
                                <ReactColorCustom
                                    color={value}
                                    onChange={this.handleCustomChange}
                                    inputChange={this.handleChange}
                                    hexValid={hexValid}
                                />
                            )}
                        </>
                    )}
                </div>
            </div>
        );
    }
}

const hexValid = (defaultColors, value) => {
    const regexp = /(^#[0-9A-Fa-f]{6}$)|(^#[0-9A-Fa-f]{3}$)/i;
    return defaultColors.includes(value) || regexp.test(value);
};
